var map = {
	"./cs.yml": 21549,
	"./de.yml": 82403,
	"./en.yml": 20348,
	"./es.yml": 54183,
	"./fr.yml": 46534,
	"./it.yml": 22048,
	"./ja.yml": 12680,
	"./ko.yml": 63868,
	"./pl.yml": 86261,
	"./ru.yml": 14580,
	"./uk.yml": 389,
	"./zh.yml": 8947
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94640;